import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getShiftJobOfferDetils , getShiftRequestIdLogs } from "../slice/workerResumeSlice";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const WorkerShiftRequestDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("token");
  console.log(id);
  
  const { shiftJobOfferDetail, loading, error } = useSelector(
    (state) => state.workerResume
  );

  
  
//   const { shiftRequstIdLogs, loading, error} = useSelector(
//         (state) => state.workerResume
//     );

const {
    shiftRequstIdLogs,
    loading: requestLogsLoading,
    error: requestLogsError,
  } = useSelector((state) => state.workerResume);
  
console.log('shiftRequstIdLogs',shiftRequstIdLogs);

  useEffect(() => {
    dispatch(getShiftJobOfferDetils({ id, token }));
  }, [id, token, dispatch]);

  useEffect(() => {
    if (!shiftJobOfferDetail || !token) return;
  
    const { shift_request_id, worker_id } = shiftJobOfferDetail;
  
    console.log("shift_request_id", shift_request_id);
    console.log("worker_id", worker_id);
  
    if (!shift_request_id || !worker_id) return;
  
    dispatch(getShiftRequestIdLogs({ shift_request_id, worker_id, token }));
  }, [shiftJobOfferDetail, token, dispatch]);
  

  // console.log("shiftJobOfferDetail", shiftJobOfferDetail);

  // if (loading) {
  //   return (
  //     <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
  //       <div className="spinner-border text-primary" role="status" />
  //     </div>
  //   );
  // }

  // /* ❌ ERROR */
  // if (error) {
  //   return <div className="text-danger text-center mt-4">{error}</div>;
  // }

  /* 📭 NO DATA */
  if (!shiftJobOfferDetail) {
    return <div className="text-center mt-4"></div>;
  }

  /* ✅ SAFE TO USE */
  const shift = shiftJobOfferDetail;
    

  const [fromAge, toAge] = shift.classroom_age_group
    ? shift.classroom_age_group.split("-")
    : ["", ""];

    const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case "accepted":
        return "bg-success";
      case "declined":
        return "bg-danger";
      default:
        return "bg-secondary";
    }
  };

  return (
    <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
      <div className="ps-2 ps-lg-4">
        <div className="d-flex align-items-center justify-content-between mb-4 border-bottom pb-3">
          <h4 className="font-weight-bold text-primary font-size-40 line-hight-2 montserrat mb-0">
            Shift Request Details
          </h4>
          <button
            className="btn btn-custom-back"
            onClick={() => navigate(-1)}
          >
            ← Back
          </button>
        </div>

        {/* LOADING */}
        {loading && <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>}

        {/* ERROR */}
        {error && <p className="text-danger">{error}</p>}

        {requestLogsLoading && <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>}

        {/* ERROR */}
        {requestLogsError && <p className="text-danger">{error}</p>}

        {!loading && !error && (
          <div className="card shadow-sm border-0 rounded-4 p-4">

            {/* 🔹 Header */}
            <div className="border-bottom pb-3 mb-4">
              <h3 className="text-primary fw-bold mb-1">{shift.title}</h3>
            </div>

            {/* 🔹 Job Info */}
            <div className="row g-3 mb-4">

              <div className="col-md-4">
                <div className="p-3 bg-light rounded-3">
                  <strong>💰 Salary</strong>
                  <div className="mt-2">{shift.salary_min} - {shift.salary_max} ({shift.ratio})</div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="p-3 bg-light rounded-3">
                  <strong>📍 Location</strong>
                  <div className="mt-2">{shift.city},{shift.state}, {shift.country}</div>
                </div>
              </div>
              shiftRequstIdLogs
              <div className="col-md-4">
                <div className="p-3 bg-light rounded-3">
                  <strong>🕒 Start</strong>
                  <div className="mt-2">{shift.start_date} {shift.start_time?.slice(0, 5)}</div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="p-3 bg-light rounded-3">
                  <strong>🕔 End</strong>
                  <div className="mt-2">{shift.end_date} {shift.end_time?.slice(0, 5)}</div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="p-3 bg-light rounded-3">
                  <strong>🎒 Classroom Age</strong>
                  <div className="mt-2">{fromAge && toAge ? `${fromAge} - ${toAge} years` : "N/A"}</div>
                </div>
              </div>

            </div>
            
            {/* 🔹 Description */}
            <div className="mb-4">
              <h6 className="fw-bold mb-2">📝 Description</h6>
              <div
                className="p-3 bg-light rounded-3"
                dangerouslySetInnerHTML={{ __html: shift.description }}
              />
            </div>

            <div className="mb-4">
              <h6 className="fw-bold mb-2"><i class="fa fa-star"></i> Status</h6>
              <div
                className="p-3 bg-light rounded-3"
                dangerouslySetInnerHTML={{ __html: shift.status }}
              />
            </div>

            {!requestLogsLoading && !requestLogsError &&
                shift.status == 'Accepted' && (
                    <div className="table-responsive">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col">Check-in Date</th>
                                    <th scope="col">Check-in Time</th>
                                    <th scope="col">Check-out Date</th>
                                    <th scope="col">Check-out Time</th>
                                    <th scope="col">Hours Worked</th>
                                </tr>
                            </thead>

                            <tbody>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   
                                {shiftRequstIdLogs.length > 0 ? 
                                    shiftRequstIdLogs.map((log, index) => (
                                        <tr key={log.id}>
                                            <td>{log.check_in_date || "-"}</td>
                                            <td>{log.check_in_time || "-"}</td>
                                            <td>{log.check_out_date || "-"}</td>
                                            <td>{log.check_out_time || "-"}</td>
                                            <td>{log.hours_worked || "-"}</td>
                                        </tr>
                                    ))
                                :
                                (
                                    <> No Logs found </>
                                ) }                                                                               
                                
                                
                            </tbody>
                        </table>
                    </div>
            )}                                                                                                                                                                                    

          </div>

        )}
      </div>
    </div>
  );
};

export default WorkerShiftRequestDetails;
